export enum OrderBy {
    BY_DATE_MOST_RECENT,
    BY_DATE_OLDEST,
    ALPHABETICAL_A_TO_Z,
    ALPHABETICAL_Z_TO_A,
}
